import { FunctionComponent } from 'react';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { useStatePageModalContext } from '../../contexts/StatePageModalContext/StatePageModalContext';
import { styled } from 'styled-components';
import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';

const Wrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    padding: 0 ${spacingHelper('extraSmall')};
  }
`;

export const StatePageVGDisclaimerFooter: FunctionComponent = () => {
  const { displayModal } = useStatePageModalContext();

  return (
    <Wrapper>
      <VGDisclaimerFooter
        onDisclaimerLinkClick={() => {
          displayModal({ name: 'vgDisclaimer' });
          trackDisclaimerModalOpen({
            inPageSource: ['state_page', 'footer_disclaimer', 'button'].join('__'),
          });
        }}
      />
    </Wrapper>
  );
};
